//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { traverseWidgetsOfContainer } from '../../utils';
export default {
  name: 'dashboard-container-widget',
  props: {
    widget: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object
  },
  data: function data() {
    return {
      defaultSlotName: '0'
    };
  },
  computed: {
    gridLayout: function gridLayout() {
      if (this.widget.widgetList.length <= 0) {
        return [{
          x: 0,
          y: 0,
          w: 4,
          h: 4,
          i: '0'
        }];
      } else {
        return this.widget.options.layout;
      }
    }
  },
  methods: {
    onRefresh: function onRefresh(item) {
      this.$set(item.options, 'isRefresh', !item.options.isRefresh);
    },
    removeSelectedChart: function removeSelectedChart(chartIndex, chartId) {
      var _this = this;
      var delInx;
      this.widget.options.layout.forEach(function (el, inx) {
        if (el.i == chartId) {
          delInx = inx;
        }
      });
      this.widget.options.layout.splice(delInx, 1);
      var chartList = this.widget.widgetList;
      if (chartList.length > 0) {
        var widgetRefName = this.designer.selectedWidgetName;
        var childrenRefNames = [];
        var fwHandler = function fwHandler(fw) {
          childrenRefNames.push(fw.options.name);
        };
        var cwHandler = function cwHandler(cw) {
          childrenRefNames.push(cw.options.name);
        };
        traverseWidgetsOfContainer(this.designer.selectedWidget, fwHandler, cwHandler);
        var nextSelected = null;
        if (chartList.length === 1) {
          //
        } else if (chartList.length === 1 + chartIndex) {
          nextSelected = chartList[chartIndex - 1];
        } else {
          nextSelected = chartList[chartIndex + 1];
        }
        this.$nextTick(function () {
          chartList.splice(chartIndex, 1);
          _this.designer.setSelected(nextSelected);
          _this.designer.formWidget.deleteWidgetRef(widgetRefName);
          _this.designer.formWidget.deletedChildrenRef(childrenRefNames);
          _this.designer.emitHistoryChange();
        });
      }
    }
  }
};